/* Kocktail — build-your-own bundle.
   Enforces bundle size + per-flavour stock, then adds the whole mix to cart in
   one /cart/add.js request. Progressive: if JS fails the page still shows the
   pool; only the bundle-add interaction needs JS. */
(function () {
  /* Same route source the rest of the cart JS uses (see kocktail-cart-add.js),
     so a locale- or market-prefixed storefront posts to the prefixed URL rather
     than a hardcoded root one. Theme.routes.cart_add_url already ends in `.js`. */
  var ROUTES = (typeof Theme !== "undefined" && Theme.routes) || {};
  var ADD_URL = ROUTES.cart_add_url || "/cart/add.js";

  /* Add one line per request, in order.
     Apps that decorate a line as it is added — pre-order, subscriptions,
     bundling — hook /cart/add.js and read the SINGLE-item shape, {id,
     quantity, properties}. Sending three bottles as one {items:[...]} request
     is a shape many of them only half-understand: the first entry gets
     processed and the rest go past untouched, which is exactly what a bundle
     of three coming back with one pre-order line looks like.
     Three requests instead of one costs two round trips on a deliberate,
     once-per-order action, and makes every bottle a first-class add. */
  function kxAddSequentially(list) {
    return list.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch(ADD_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(item)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        });
      });
    }, Promise.resolve());
  }

  var CART_URL = ROUTES.cart_url || "/cart";

  function money(cents) {
    return "£" + (cents / 100).toFixed(2);
  }

  function initBundle(root) {
    var size = parseInt(root.dataset.size, 10) || 4;
    var lowAt = parseInt(root.dataset.lowstock, 10) || 5;
    var bundleCents = root.dataset.price ? parseInt(root.dataset.price, 10) : null;
    var returnUrl = root.dataset.return || CART_URL;
    var bundleLabel = root.dataset.label || "";
    var discountCode = root.dataset.discount || "";
    // The property name is set on the section; the value is each product's own
    // custom.pdp_ship_note, rendered onto its row.
    var shipProp = root.dataset.shipProp || "";

    function shipFor(vid) {
      var row = root.querySelector('[data-kx-row][data-vid="' + vid + '"]');
      return (row && row.getAttribute("data-ship")) || "";
    }

    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-kx-row]"));
    var pips = root.querySelectorAll("[data-kx-pips] .kx-bb__pip");
    var pickedEl = root.querySelector("[data-kx-picked]");
    var countEl = pickedEl ? pickedEl.closest(".kx-bb__count") : null;
    var statusEl = root.querySelector("[data-kx-status]");
    var submitEl = root.querySelector("[data-kx-submit]");
    var ctaLabel = root.querySelector("[data-kx-cta-label]");
    var saveEl = root.querySelector("[data-kx-save]");
    var errEl = root.querySelector("[data-kx-err]");

    var picks = {}; // vid -> qty

    // set initial stock labels
    rows.forEach(function (row) {
      var stock = parseInt(row.dataset.stock, 10);
      var avail = row.dataset.avail === "true";
      var wrap = row.querySelector("[data-kx-stock]");
      var label = row.querySelector("[data-kx-stock-label]");
      // Guarded the same way as kocktail-pdp-buy.js: a row rendered without a
      // stock element (an app block, a merchant-edited template) used to throw
      // here and take the whole picker's wiring down with it.
      if (!wrap || !label) return;
      if (!avail || stock <= 0) {
        wrap.classList.add("is-out");
        label.textContent = "Sold out";
        var soldOutAdd = row.querySelector("[data-kx-add]");
        if (soldOutAdd) soldOutAdd.disabled = true;
      } else if (stock < 9999 && stock <= lowAt) {
        wrap.classList.add("is-low");
        label.textContent = "Low stock · " + stock + " left";
      } else {
        label.textContent = "In stock";
      }
    });

    function totalPicked() {
      return Object.keys(picks).reduce(function (s, k) { return s + picks[k]; }, 0);
    }

    function render() {
      var picked = totalPicked();
      var remaining = size - picked;

      if (pickedEl) pickedEl.textContent = picked;
      if (countEl) countEl.classList.toggle("is-full", picked === size);
      pips.forEach(function (p, i) { p.classList.toggle("is-on", i < picked); });

      if (statusEl) {
        if (remaining <= 0) {
          statusEl.textContent = "Bundle ready ✓";
          statusEl.classList.add("is-ready");
        } else {
          statusEl.textContent = "Add " + remaining + " more flavour" + (remaining > 1 ? "s" : "");
          statusEl.classList.remove("is-ready");
        }
      }

      if (bundleCents != null && saveEl) {
        var listTotal = rows.reduce(function (s, row) {
          var q = picks[row.dataset.vid] || 0;
          return s + q * parseInt(row.dataset.price, 10);
        }, 0);
        var save = listTotal - bundleCents;
        saveEl.textContent = picked === size && save > 0 ? "· save " + money(save) : "";
      }

      // per-row controls
      rows.forEach(function (row) {
        var vid = row.dataset.vid;
        var stock = parseInt(row.dataset.stock, 10);
        var avail = row.dataset.avail === "true";
        var qty = picks[vid] || 0;
        var stepper = row.querySelector("[data-kx-stepper]");
        var addBtn = row.querySelector("[data-kx-add]");
        var qtyEl = row.querySelector("[data-kx-qty]");
        var up = row.querySelector("[data-kx-up]");

        // Every control is optional here, as in kocktail-pdp-buy.js — one missing
        // node must not stop the remaining rows from re-rendering.
        if (qtyEl) qtyEl.textContent = qty;
        if (qty > 0) {
          if (stepper) stepper.hidden = false;
          if (addBtn) addBtn.hidden = true;
          if (up) up.disabled = remaining <= 0 || qty >= stock;
        } else {
          if (stepper) stepper.hidden = true;
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.disabled = !avail || stock <= 0 || remaining <= 0;
          }
        }
      });

      if (submitEl) {
        var ready = picked === size;
        submitEl.disabled = !ready;
        if (ctaLabel) ctaLabel.textContent = ready ? "Add bundle to basket" : "Pick " + (size - picked) + " more";
      }
    }

    function setQty(vid, q) {
      if (q <= 0) delete picks[vid];
      else picks[vid] = q;
      render();
    }

    rows.forEach(function (row) {
      var vid = row.dataset.vid;
      var stock = parseInt(row.dataset.stock, 10);
      var addEl = row.querySelector("[data-kx-add]");
      var upEl = row.querySelector("[data-kx-up]");
      var dnEl = row.querySelector("[data-kx-dn]");
      if (addEl) addEl.addEventListener("click", function () {
        if ((totalPicked()) < size) setQty(vid, 1);
      });
      if (upEl) upEl.addEventListener("click", function () {
        var q = (picks[vid] || 0);
        if (totalPicked() < size && q < stock) setQty(vid, q + 1);
      });
      if (dnEl) dnEl.addEventListener("click", function () {
        setQty(vid, (picks[vid] || 0) - 1);
      });
    });

    // render() already treats submitEl as optional; this listener did not, so a
    // picker rendered without its button threw instead of degrading. Guard the
    // listener rather than returning from initBundle — an early return here would
    // also skip the render() at the end of this function, which is what syncs the
    // pips, the counter and the save line on first paint.
    if (submitEl) submitEl.addEventListener("click", function () {
      if (totalPicked() !== size) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ""; }
      submitEl.disabled = true;
      if (ctaLabel) ctaLabel.textContent = "Adding…";

      // Group the mix under one label + shared line so the cart reads as a
      // single bundle and a discount can target it.
      var groupId = "kx-" + Date.now();
      // A fresh properties object per line, not one shared between them. Each
      // bottle carries its own dispatch note — a mixed bundle can hold one
      // that ships now and one that does not — so a single object would put
      // the last bottle's date on all of them.
      var items = Object.keys(picks).map(function (vid) {
        var it = { id: parseInt(vid, 10), quantity: picks[vid] };
        var props = {};
        if (bundleLabel) {
          props["Bundle"] = bundleLabel;
          props["_kx_bundle"] = groupId;
        }
        var ship = shipFor(vid);
        if (shipProp && ship) props[shipProp] = ship;
        if (Object.keys(props).length) it.properties = props;
        return it;
      });

      kxAddSequentially(items)
        .then(function () {
          // Auto-apply the discount code (if any), then land on the cart.
          if (discountCode) {
            window.location = "/discount/" + encodeURIComponent(discountCode) +
              "?redirect=" + encodeURIComponent(returnUrl || "/cart");
          } else {
            window.location = returnUrl;
          }
        })
        .catch(function (e) {
          submitEl.disabled = false;
          if (ctaLabel) ctaLabel.textContent = "Add bundle to basket";
          if (errEl) {
            errEl.hidden = false;
            errEl.textContent = (e && e.description) ? e.description : "Sorry — something went wrong. Please try again.";
          }
        });
    });

    render();

    // This flow navigates to the cart, so the browser's back button restores
    // the page from the back/forward cache exactly as it was left: mid-submit,
    // button disabled and still reading "Adding...". render() re-derives the
    // button from the picks, so it is the reset.
    window.addEventListener("pageshow", function (e) { if (e.persisted) render(); });
  }

  function init() {
    // The PDP renders its inline picker with this same data-kx-bundle hook,
    // but kocktail-pdp-buy.js owns that one (it sits inside the product
    // form). Wiring it here too gave two scripts independent pick-state over
    // the same rows, and after pdp-buy's in-place add reset ITS state, the
    // stale copy here repainted the picker as still full on the next click.
    document.querySelectorAll("[data-kx-bundle]").forEach(function (el) {
      if (!el.closest("form[data-kx-cart-form]")) initBundle(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
